export const MIN_PLAYER_NAME_LENGTH = 2;
export const MAX_PLAYER_NAME_LENGTH = 15;

export const normalizePlayerName = (value) => (typeof value === 'string' ? value.trim() : '');

export const validatePlayerName = (value) => {
  const normalizedName = normalizePlayerName(value);

  if (!normalizedName) {
    return {
      isValid: false,
      normalizedName: '',
      error: 'Player name is required.',
    };
  }

  if (normalizedName.length < MIN_PLAYER_NAME_LENGTH) {
    return {
      isValid: false,
      normalizedName,
      error: `Player name must be at least ${MIN_PLAYER_NAME_LENGTH} characters.`,
    };
  }

  if (normalizedName.length > MAX_PLAYER_NAME_LENGTH) {
    return {
      isValid: false,
      normalizedName,
      error: `Player name must be ${MAX_PLAYER_NAME_LENGTH} characters or less.`,
    };
  }

  return {
    isValid: true,
    normalizedName,
    error: '',
  };
};
